import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import { AppBar, Box, Button, Card, CardContent, CircularProgress, Grid, IconButton, Modal, Paper, Tab, Tabs, TextField, Typography } from '@material-ui/core'
import { Page, Header } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import SendIcon from '@material-ui/icons/Send'
import AddIcon from '@material-ui/icons/Add'
import DoneIcon from '@material-ui/icons/Done'
import useRouter from 'utils/useRouter'
import { useAuth } from 'hooks/useAuth'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import useStyles from './styles'
import { TabelaSolicitacao } from './Componentes/TabelaSolicitacao'

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export const Despachos = (props) => {
  moment.locale('pt-br', localization)
  const { route } = props
  const classes = useStyles()
  const router = useRouter()
  const { currentUser } = useAuth()
  const [setor, setSetor] = useState(null)
  const [tab, setTab] = useState(0)
  const [refresh, setRefresh] = useState(false)

  const handleChangeTab = (event, newValue) => {
    setTab(newValue)
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <>
            <AutocompleteNative
              value={setor}
              name="setor"
              noOptionsText="Sem informações"
              options={currentUser.setores}
              onChange={(event, newValue) => {
                setSetor(newValue)
              }}
              getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              className={classes.selectSetor}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Selecione o setor..."
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
            {setor && (
              <div className={classes.menuSuperior}>
                <AppBar position="static" className={classes.appBar}>
                  <Tabs value={tab} onChange={handleChangeTab} aria-label="simple tabs example" indicatorColor="secondary">
                    <Tab label="Em aberto" {...a11yProps(0)} />
                    <Tab label="Concluidos" {...a11yProps(1)} />
                  </Tabs>
                </AppBar>
                <TabPanel value={tab} index={0}>
                  <TabelaSolicitacao idSetor={setor.id} situacao="ABERTO" refresh={refresh} />
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  <TabelaSolicitacao idSetor={setor.id} situacao="CONCLUIDO" refresh={refresh} />
                </TabPanel>
              </div>
            )}
          </>
        </CardContent>
      </Card>
    </Page>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
